import React from 'react'
import { Link } from 'react-router-dom';
import { errors } from '../../utlis/errors';

export const NotFound = ({error}) => {

  let title = "";
  let description = "";
  if (error.status == errors.CONN_ERROR)
  {
    title = "Connection Error";
    description = "Opp! Please check your internet connection and try again";
  } else if (error.status == errors.PARSING_ERROR)
  {
    title = "Internal Server Error";
    description = "Oops! Something went wrong on our server. Please try again later.";
  }
  return (
    <div style={styles.container}>
      <img src='./SNS_GOLD.png' alt="" />
      <h1 style={styles.heading}>{title}</h1>
      <p style={styles.message}>{description}</p>
      <Link to="/" style={styles.link}>Go back to Home</Link>
    </div>
  );
};

const styles = {
  container: {
    textAlign: 'center',
    padding: '20px',
  },
  heading: {
    fontSize: '24px',
    color: '#333',
  },
  message: {
    fontSize: '16px',
    color: '#666',
  },
  link: {
    marginTop: '20px',
    fontSize: '18px',
    color: '#007BFF',
    textDecoration: 'none',
    fontWeight: 'bold',
  },
};
